import React from 'react';
import { Link } from 'gatsby';
// import RequestDemo from '../components/RequestDemo';
import logo from '../img/effi-logo-colored.webp';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="row">
        <div className="col-lg-5 col-12 d-flex justify-content-lg-start justify-content-center">
          <div className="footer-logo ">
            <img src={logo} className="img-fluid logo" alt="Effi logo" />
            <p className="pt-3">It’s Time. Take Action. Get Started.</p>
          </div>
        </div>

        <div className="col-lg-7 col-12 d-flex flex-column justify-content-lg-end justify-content-center align-items-lg-end">
          <div className="subscribe-form form-dark">
            {/* <RequestDemo text="Request 14-Day Free Trial" /> */}
          </div>
          <ul className="footer-links">
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
            <li>
              <a href="https://blog.effi.com.au/">Blog</a>
            </li>
            <li>
              <Link to="/faq">FAQ</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-and-conditions">Terms of Service</Link>
            </li>
          </ul>
          <ul className="social-links">
            <li>
              <a
                href="https://twitter.com/EffiTechnologi1"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Twitter"
              >
                <i className="fab fa-twitter" />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/effi-tech"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Linkedin"
              >
                <i className="fab fa-linkedin" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
